import styled from '@emotion/styled';

export const QueueIdCell = styled.span`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const QueueIdText = styled.span`
  cursor: default;
`;

export const ActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
`;
